@if (isLoggedIn && !isLoginPage && !is404Page) {
  <navi></navi>
}
<router-outlet></router-outlet>
@if (isLoginPage) {
  <footer></footer>
}
@if (!isLoginPage) {
  <flopfooter></flopfooter>
}
